/**
 * 어떻게 결제할지 (만나서, 선결제, 비대면등..)
 */
export default {
    ON_SITE_PAYMENT: {
        code: 'ON_SITE_PAYMENT',
        text: '도착지결제',
    },
    PRE_PAYMENT: {
        code: 'PRE_PAYMENT',
        text: '선결제',
    },
    ON_SITE_QUICK_PAYMENT: {
        code: 'ON_SITE_QUICK_PAYMENT',
        text: '착불',
    },
    PRE_QUICK_PAYMENT: {
        code: 'PRE_QUICK_PAYMENT',
        text: '선불',
    },
    UNTACT: {
        code: 'UNTACT',
        text: '비대면',
    },
    ETC: {
        code: 'ETC',
        text: '기타',
    },
};
